<template lang="pug">
.file-icon-group(:style="iconStyle")
  .file-icon-state(v-if="badgeState.src", :class="{ readonly: readonly }")
    img.lightStyle(v-bind="badgeState", @click.stop="updateLight(row, 0)")
  img.file-icon-v(v-file="row", :alt="row.fileName")
</template>
<script>
import FileLightFlag from "@/CommonDP/components/fileLightFlag.vue";
import { fileDirective } from "./file";
import notlightweight from "@/CommonDP/assets/projectMg/notlightweight.png";
import icon_visual from "@/CommonDP/assets/projectMg/icon_visual.png";
import icon_visua_error from "@/CommonDP/assets/projectMg/icon_visua_error.png";
import Inlightweight from "@/CommonDP/assets/projectMg/Inlightweight.png";
export default {
  directives: {
    file: fileDirective
  },
  extends: FileLightFlag,
  props: { iconSize: { default: 24, type: Number }, stateSize: { default: 12, type: Number }},
  computed: {
    iconStyle() {
      return `--icon-size:${this.iconSize}px;--state-size:${this.stateSize}px`;
    },
    badgeState() {
      const obj = {};
      if (this.isWaiting) {
        obj.title = "未轻量化";
        obj.src = notlightweight;
      } else if (this.isSuccess) {
        obj.title = !this.formFlow ? "轻量化成功,点击重新轻量化" : "";
        obj.src = icon_visual;
      } else if (this.isFail) {
        obj.title = this.errorMsg;
        obj.src = icon_visua_error;
      } else if (this.isDealing) {
        obj.src = Inlightweight;
        obj.title = "轻量化中";
        obj.style = { animation: "rotating 2s linear infinite", top: "38%" };
      }
      return obj;
    }
  }
};
</script>
<style lang="scss" scoped >
.file-icon {
  &-group {
    --out-width: 1px;
    position: relative;
    width: var(--icon-size);
    height: var(--icon-size);
    flex-shrink: 0;
  }

  &-v {
    object-fit: contain;
    width: 100%;
    height: 100%;
  }
  // &-state ~ &-v {
  //   --size: calc(var(--state-size) / 2 + var(--out-width) * 2);
  //   --offset: calc((var(--icon-size) - var(--state-size) - var(--out-width)) / 2);
  //   mask-mode: luminance;
  //   mask-position: var(--offset) var(--offset);
  //   mask-image: radial-gradient(#000 var(--size), #fff calc(var(--size) + var(--out-width)));
  // }

  &-state {
    position: absolute;
    right: 0;
    bottom: 0;
    width: var(--state-size);
    height: var(--state-size);
    border-radius: var(--state-size);
    background-color: #fff;
    box-shadow: 0 0 0 2px #fff;
    text-align: center;
    z-index: 1;
    cursor: pointer;
    &.readonly {
      pointer-events: none;
    }

    > .lightStyle {
      display: block;
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }
}
</style>
